import { TRESPONSE_ORDER_TIMELINE_CARD_DATA } from '@monorepo/types';
import { ModifiersZTableModel } from '../../table.modifier';

export const ORDER_TIMELINE_CARD_TABLE_MODEL = {
  createModel: (allocationDetails: TRESPONSE_ORDER_TIMELINE_CARD_DATA) => {
    return ModifiersZTableModel.createTableModel(
      allocationDetails.data,
      {
        padding: 8,
        headerConfig: allocationDetails.headerInfo.map((h) => ({
          type: 'TEXT_CELL' as const,
          text: h.displayName,
          align: 'center' as const,
          widthInPx: 100,
        })),
      },
      (item) => {
        return {
          type: 'ROW',
          rowItem: item,
          cells: allocationDetails.headerInfo.map((h) => ({
            type: 'TEXT_CELL' as const,
            text: item[h.key] ?? '- -',
            align: 'center' as const,
          })),
        };
      },
    );
  },
};
